// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CRn8h","name":"styles_name__Kgxku","phone":"styles_phone__16tBd"};